import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Modal } from 'antd';
import { setModalState } from '../../../../reducers/Modal/actions';
import { MODAL_PARAM_WHITELABEL_BUYERS_TRAINING } from '../../../../reducers/Modal/types';
import { ZorbaButton } from '../../../../components/forms';
import {
  getUserData,
  updateUserDetails,
  fetchPartnerConfig,
} from '../../../../reducers/Auth/actions';
import { isMobile } from '../../../../services/clientService';

import './index.scss';

export const WhiteLabelTrainingModal = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const { userDetails, isAppLoading, isAuthLoading, partnerConfig } = useSelector(
    ({ AuthReducer }) => AuthReducer,
  );
  const { isWhiteLabelTrainingModalOpen } = useSelector(
    ({ ModalReducer }) => ModalReducer,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      !isAppLoading &&
      !isAuthLoading &&
      userDetails &&
      !!userDetails.defaultOrganization?.marketplacePartner &&
      !userDetails?.watchedWhitelabelTrainingModalAt
    ) {
      dispatch(setModalState(MODAL_PARAM_WHITELABEL_BUYERS_TRAINING, true));
    }
  }, [userDetails, isAuthLoading, isAppLoading]);

  useEffect(() => {
    if (userDetails?.defaultOrganization?.marketplacePartner) {
      dispatch(fetchPartnerConfig(userDetails.defaultOrganization.marketplacePartner));
    }
  }, [userDetails?.defaultOrganization?.marketplacePartner, dispatch]);

  const handleCloseModal = async () => {
    setIsLoading(true);
    if (!userDetails?.watchedWhitelabelTrainingModalAt) {
      dispatch(
        updateUserDetails(
          { watchedWhitelabelTrainingModalAt: new Date() },
          () => {
            dispatch(
              setModalState(MODAL_PARAM_WHITELABEL_BUYERS_TRAINING, false),
            );
          },
        ),
      );
    } else {
      history.push('/buybox');
    }
    setIsLoading(false);
    dispatch(getUserData());
    dispatch(setModalState(MODAL_PARAM_WHITELABEL_BUYERS_TRAINING, false));
  };

  const videoUrl =
    partnerConfig?.videoUrl ??
    'https://www.youtube.com/embed/bhclYR_bZlk?si=vOJFkiNHcF7zeKRH';

  return (
    <Modal
      open={isWhiteLabelTrainingModalOpen}
      footer={null}
      className="training-modal"
      destroyOnClose
      centered={!isMobile()}
      width={!isMobile() ? 740 : ''}
      style={isMobile() ? { top: 200 } : {}}
      closable={Boolean(userDetails?.watchedPreDealsTrainingAt)}
      onCancel={
        userDetails?.watchedPreDealsTrainingAt ? handleCloseModal : null
      }
    >
      <div className="video-responsive">
        <div className="title-container">
          <span className="title">
            Exclusive Off-Market Properties for Smart Real Estate Investors
          </span>
          <span className="description">
            Access 5,000+ exclusive, vetted investment properties every
            month—before they hit the market. Get expert support every step of
            the way.
          </span>
        </div>
        <iframe
          // width="560" height="315"
          width={!isMobile() ? '640' : ''}
          height={!isMobile() ? '360' : ''}
          src={videoUrl}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
        {/* <iframe
          width={!isMobile() ? '640' : ''}
          height={!isMobile() ? '360' : ''}
          src={videoSrc}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        /> */}
      </div>
      <div className="buttons-container">
        <ZorbaButton
          fullWidth={false}
          onClick={handleCloseModal}
          disabled={isLoading}
          loading={isLoading}
        >
          Setup Your Buy Box
        </ZorbaButton>
      </div>
    </Modal>
  );
};
